module.exports = __webpack_public_path__ + "static/media/MinhAvatar.cc4f7f2e.png";